const localizers = {
  'loading.msg': () => `ロード中...`,
  'SASServer.genericError.msg': () => `サーバーにアクセスできません。`,
  'SASReport.genericError.msg': () => `選択したレポートをロードできません。`,
  'SASReportImage.genericError.msg': () => `レポートイメージのロードに失敗しました。`,
  'SASReportImage.imageNotSupported.msg': () => `イメージはこのレポートコンテンツの種類でサポートされていません。`,
}
export default localizers;
